import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private httpClient: HttpClient, private router: Router) {}

  login(body: any): Observable<any> {
    const url = `${this.baseUrl}/scperformance/authenticate_user`;
    return this.httpClient.post<any>(url, body).pipe(
      map((data) => {
         sessionStorage.clear();
        localStorage.clear();
        if (!data.step) {
          localStorage.setItem('username', data.response);
          localStorage.setItem('authToken', data.access_token);
          localStorage.setItem('authRefToken', data.refresh_token);
          localStorage.setItem('subUsername', data.main_username);
          localStorage.setItem('loginPic', data.pic);
          localStorage.setItem('email', data.email);
        }
        return data.response;
      })
    );
  }
  verifyOtp(body: any) {
    const url = `${this.baseUrl}/scperformance/verify_otp`;
    return this.httpClient.post(url, body).pipe(catchError(this.errorHandler));
  }

  sendOtp(body: any) {
    const url = `${this.baseUrl}/scperformance/forgot/request_otp`;
    return this.httpClient.post(url, body).pipe(catchError(this.errorHandler));
  }
  passwordChange(body: any) {
    const url = `${this.baseUrl}/scperformance/forgot/verify_otp`;
    return this.httpClient.post(url, body).pipe(catchError(this.errorHandler));
  }
  isAuthenticated(): boolean {
    const token = localStorage.getItem('authToken');
    if (token) {
      return true;
      // !this.tokenService.isTokenExpired(token);
    }
    return false;
  }
  logout() {
    localStorage.clear();
    this.router.navigateByUrl('');
  }

  refreshToken(body: any) {
    const url = `${this.baseUrl}/scperformance/refresh_tokens`;
    return this.httpClient.post(url, body).pipe(catchError(this.errorHandler));
  }
  errorHandler(error: HttpErrorResponse) {
    return throwError(() => error || 'Server Error');
  }
}
